module.exports = __webpack_public_path__ + "img/3.6628d1c2.png";